// MARK: used in v2.
import { isConsolidatedProduct } from "./shop"
export const trackSegmentEvent = (
  event: string,
  data: Record<string, any> = {}
): void => {
  if (typeof window === "undefined" || !window.analytics) {
    return console.warn(`Failed to track event: segment is undefined`)
  }

  return window.analytics.track(event, data)
}

export const trackSegmentLinkEvent = (
  element: React.ReactNode,
  event: string,
  data: Record<string, any> = {}
): void => {
  if (typeof window === "undefined" || !window.analytics) {
    return console.warn(`Failed to track event: segment is undefined`)
  }

  return window.analytics.trackLink(element, event, data)
}

export const pushToDataLayer = (data: Record<string, any>): void => {
  if (typeof window === "undefined" || !window.dataLayer) {
    return console.warn(
      `Failed to push to data layer: window.dataLayer is undefined`
    )
  }

  return window.dataLayer.push(data)
}

export const getCookie = (name: string) => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`))
    ?.split("=")[1]
}

export const isMobileDevice = () => {
  const conditions = [
    "Tablet",
    "Mobile",
    "Mobile Safari",
    "IEMobile/xyz",
    "Mobile/xyz",
    "Edge/ ",
  ]

  return conditions.some((condition) => navigator.userAgent.includes(condition))
}

export const getTrackerEventId = (event: string) => {
  if (typeof window === "undefined" || !window.analytics) {
    return console.warn(`Failed to get tracker event id: segment is undefined`)
  }
  // We first try use anonymousId since it's faster but not always available by the time we call this
  // ToDo: try figure out what's causing this race condition
  return `${window?.analytics?.user?.().anonymousId() ?? window.crypto.randomUUID()}#${event}#${new Date().toISOString()}`
}

/**
 * Takes in an array of consolidated cart items
 * that were added to the cart and sends a
 * tracking event to segment.
 */
export const trackAddToCart = (
  addedProducts: YocoCom.ConsolidatedCartItem[]
) => {
  trackSegmentEvent("shop_add_to_cart", {
    add_to_cart_total: addedProducts
      .reduce((acc, item) => acc + Number(item.price) * item.quantity, 0)
      .toFixed(2),
    contents: addedProducts.map((item) => ({
      id: isConsolidatedProduct(item) ? item.sku : item.bundleCode,
      quantity: item.quantity,
      item_price: Number(item.price).toFixed(2),
    })),
    event_id: getTrackerEventId("shop_add_to_cart"),
  })
}
